module.exports = __webpack_public_path__ + "img/transaction-record.4209fb19.svg";